import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoutePartCMRSignatureAgents, RoutePartCMRSignatureAgentsEnum } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { PhaseController } from '@shared/src/public-api';

@Component({
    selector: 'shared-phase-cmr-icon-sign-viewer',
    templateUrl: './shared.phase.cmr.icon.sign.viewer.component.html',
    styleUrls: ['./shared.phase.cmr.icon.sign.viewer.component.scss']
})
export class SharedPhaseCmrIconSignViewerComponent {

    constructor(private phaseController: PhaseController) { 

    }

    public agent: RoutePartCMRSignatureAgents;
    public allSigned: boolean = false;

    public __phase: PhaseCardItemDto;
    @Input()
    public set phase(value: PhaseCardItemDto) {
        if (this.__phase == value)
            return;
        this.__phase = value;
        this.loadSignedStatus();
    }
    public get phase(): PhaseCardItemDto {
        return this.__phase;
    }


    isValidAgent(): boolean{
        if(this.agent == null || RoutePartCMRSignatureAgents.none == this.agent)
            return false;
        return true;
    }
    loadSignedStatus() {
        this.agent = RoutePartCMRSignatureAgentsEnum.getDefaultAgentByPhase(this.phase);
        
        if(!this.isValidAgent())
            return;

        this.phaseController.allCMRsSigned(this.phase.phaseId, this.agent).subscribe(d => {
            this.allSigned = d;
        });
    }

}
